import { createSlice } from "@reduxjs/toolkit"
import { missionFormObject } from "@form/mairieMissionFormFields"
import { seasonFormObject } from "@form/seasonFormFields"

const missionSlice = createSlice({
  name: 'mission',
  initialState: {
    missions: null,
    missionPilots: null,
    missionContacts: null,
    mairieMissionFormObject: { ...missionFormObject },
    seasonFormObject: { ...seasonFormObject },
    errors: {}
  },
  reducers: {
    updateMissionFormObject: (state, action) => {
      state.mairieMissionFormObject = action.payload
    },
    initMissionFormObject: (state) => {
      state.mairieMissionFormObject = { ...missionFormObject }
    },
    updateSeasonFormObject: (state, action) => {
      state.seasonFormObject = action.payload
    },
    initSeasonFormObject: (state) => {
      state.seasonFormObject = { ...missionFormObject }
    },
    updateMissions: (state, action) => {
      state.missions = action.payload
    },
    updateMissionPilots: (state, action) => {
      state.missionPilots = action.payload
    },
    updateMissionContacts: (state, action) => {
      state.missionContacts = action.payload
    },
    addMission: (state, action) => {
      state.missions = [...state.missions, action.payload]
    },
    addMissionContact: (state, action) => {
      const missionContact = action.payload
      state.missionContacts = { ...state.missionContacts, [missionContact.id]: missionContact }
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const {
  updateMissionFormObject,
  initMissionFormObject,
  updateSeasonFormObject,
  initSeasonFormObject,
  updateMissions,
  updateMissionPilots,
  addMissionContact,
  updateMissionContacts,
  updateErrors
} = missionSlice.actions

export default missionSlice.reducer